import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import PersonIcon from 'material-ui-icons/Person';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from 'material-ui/Dialog';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

/*
const sleep = ms => new Promise(res => setTimeout(res, ms));
const {cookies}  = this.props;
let date = new Date();
date.setTime(date.getTime()+(7*24*60*60*1000));
*/

class AutoOpen extends Component {

  constructor(props){
    super(props);

    this.state = {
      show_alert: false,
    };
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  componentDidMount() {

    if (isMobile){
      this.onDid();
    }
  }

  onDid() {

    let profile_url = this.props.data["profile url"];
    if (window.location.href.includes('open_profile')){

      var winNav = window.navigator;
      var isIOSChrome = winNav.userAgent.match("CriOS");
      if (isIOSChrome) {
         this.setState({
           show_alert: true
         });
      } else {
        window.history.replaceState(null, null, '/console/user/'+this.props.data["access id"]);
        window.history.pushState(null, null,'/console/user/'+this.props.data["access id"])
        window.location.href = profile_url;
      }
    }
  }
  /*
  if (cookies.get('url_opens')) {
    if (cookies.get('url_opens') == profile_url) {

      cookies.set('url_opens', null, { path: '/', expires: date });

    } else {
      cookies.set('url_opens', profile_url, { path: '/', expires: date });
    }
  } else {
    cookies.set('url_opens', profile_url, { path: '/', expires: date });
  }

  this.setState({
    show_alert: true
  });
  */

  closeAlert() {
    this.setState({
      show_alert: false
    })
  }

  headToSite(data) {
    let profile_url = data["profile url"];
    window.location.href = profile_url;
  }

  render(){
    const { classes, theme, location, data } = this.props;
    const { show_alert } = this.state;

    let profile_url = data["profile url"];

    //alert(this.state.show_alert)
    return(
      <div>
        <Dialog className={classes.root} open={show_alert} onRequestClose={() => this.closeAlert()}>
          <DialogTitle>Heading to Dating Site</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tap OK to continue to the candidate's dating site.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={() => this.closeAlert()}>
              CANCEL
            </Button>
            <Button color="primary" onClick={() => this.headToSite(data)}>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        priority: state.dashboard.priority,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}
export default withCookies(withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(AutoOpen))));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/AutoOpen/index.js